// Device kind — 端末区分 (phone / tablet / desktop)
// (docs/_wip/pen-usage-analytics-2026-08-18.md §11.2 / §11.3).
//
// `layout.ts` (Classic/Modern) と同じ流儀で shared/ に置く. `room.join.device`
// (入室時) の 1 箇所でしか使わないが、telemetry 用の cross-domain payload
// piece という位置付けは layout と同じなので `shared/` に揃える.
//
// 定義 = 「**入室時点で出していたシェルと入力方式**」(端末そのものの分類では
// ない). web 側 (`useLayoutPreference` が持つ `isMobile` / `isPhoneViewport`
// と `matchMedia('(pointer: coarse)')`) が入室時に 1 回だけ読んで決める純関数
// の出力をそのまま送る:
//   - `phone`   : `isPhoneViewport` が true (= 実際にフォンシェルを表示中).
//                 幅 < 640 の PC ウィンドウや iPad の Split View も phone に
//                 数える (フォンシェルが出ているため).
//   - `tablet`  : `(pointer: coarse)` (= タッチ主体の primary pointer) かつ
//                 phone でない (例: iPad 1024×768).
//   - `desktop` : それ以外 (primary pointer が fine).
//
// server はこの値で分岐しない (= 判定に使わない、記録するだけ. `layout.ts`
// と同じ telemetry-only の位置付け). User-Agent では判定しない — iPad の
// Chrome/Safari は Mac を名乗るため (2026-09-27 nginx ログで確認済み).
//
// **UU 単位の端末分類には向かない**: 同じ人が session ごとに phone / tablet
// を行き来しうる (回転・リサイズは追跡しない、入室時点のスナップショット).
// 目的 (= Classic を選べる母数を端末別に見る) には十分.
import { z } from 'zod';
export const DEVICE_KINDS = ['phone', 'tablet', 'desktop'];
export const deviceKindSchema = z.enum(DEVICE_KINDS);
//# sourceMappingURL=device.js.map